import { PasswordButton} from '../../../components/buttons';

import Input from '../../../components/input-with-label';

import React from 'react';

import Section from './account-section';
import MeApi from "../../../lib/users/me-api";
import AlertManager from "../../../managers/alert/alert-manager";

export default class AccountSecurity extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            password : '',
            password_confirmation : '',
            errors: []
        };
    }


    componentDidMount() {
        this.props.onSaveSet(this.handleSave.bind(this));
    }

    handleSave() {

        if(this.state.password !== this.state.password_confirmation) {
            this.setState({errors : ['Passwords do not match']});
            return;
        }
        MeApi.update(this.state, (errors) => {
            this.setState({
                errors : errors.password
            });
        }).then(response => {
            AlertManager.success('Password updated');
            this.setState({ errors: [] })
        });
    }

    handleChange(e) {
        this.setState({[e.target.name] : e.target.value});
    }

    render() {
        const { password, password_confirmation } = this.state;

        return (
            <div class="account__security">
                <Section title="Security" subtitle="To change your password, please complete the fields below">
                    {/*<div class="website-row">*/}
                    {/*    <Input type="password" name="password_current" value={password} placeholder="New password" onChange={this.handleChange.bind(this)}/>*/}
                    {/*    <PasswordButton />*/}
                    {/*</div>*/}
                    <div class="website-row">
                        <Input type="password" name="password" errors={this.state.errors} value={password} placeholder="New password" onChange={this.handleChange.bind(this)}/>
                        <Input type="password" name="password_confirmation"  value={password_confirmation} placeholder="Confirm Password" onChange={this.handleChange.bind(this)}/>
                    </div>
                </Section>
            </div>
        );
    }

}
